window.ComponentHubRFQ = {
  cart: [],

  init: function() {
    this._loadCart();
    this.updateCartUI();
    this._bindEvents();
    if (window.location.pathname.indexOf('/pages/rfq') > -1) {
      this.renderFullCart();
    }
  },

  _loadCart: function() {
    try {
      var saved = localStorage.getItem('ch_rfq_cart');
      if (saved) {
        this.cart = JSON.parse(saved);
      }
    } catch (e) {
      this.cart = [];
    }
  },

  _saveCart: function() {
    localStorage.setItem('ch_rfq_cart', JSON.stringify(this.cart));
    this.updateCartUI();
  },

  addToCart: function(productName, sku, imageUrl, quantity, productUrl) {
    if (!productName && !sku) return;

    var pName = productName || sku;
    var pSku = sku || productName;

    var existing = this.cart.find(function(item) {
      return item.sku === pSku;
    });

    if (existing) {
      existing.quantity = parseInt(existing.quantity || 1) + parseInt(quantity || 1);
      if (productUrl) existing.url = productUrl;
    } else {
      this.cart.push({
        id: 'item_' + Date.now(),
        name: pName,
        sku: pSku,
        image: imageUrl || '',
        quantity: parseInt(quantity || 1),
        targetPrice: '',
        notes: '',
        url: productUrl || ''
      });
    }

    this._saveCart();
    this.openCart();
    if (window.location.pathname.indexOf('/pages/rfq') > -1) {
      this.renderFullCart();
    }
  },

  addManualItem: function(name, sku, quantity, targetPrice, notes) {
    if (!name && !sku) {
      alert('製品名または型番を入力してください。');
      return false;
    }

    var pName = name || sku;
    var pSku = sku || name;

    this.cart.push({
      id: 'item_manual_' + Date.now(),
      name: pName,
      sku: pSku,
      image: '',
      quantity: parseInt(quantity || 1),
      targetPrice: targetPrice || '',
      notes: notes || ''
    });

    this._saveCart();
    this.renderFullCart();
    return true;
  },

  submitManualItemForm: function(e) {
    if (e) e.preventDefault();
    var nameInput = document.getElementById('manual-name');
    var skuInput = document.getElementById('manual-sku');
    var qtyInput = document.getElementById('manual-qty');
    var priceInput = document.getElementById('manual-price');
    var notesInput = document.getElementById('manual-notes');

    if (!nameInput || !skuInput) return;

    var name = nameInput.value.trim();
    var sku = skuInput.value.trim();
    var qty = qtyInput.value.trim();
    var price = priceInput.value.trim();
    var notes = notesInput.value.trim();

    if (!name && !sku) {
      alert('製品名または型番を入力してください。');
      if (nameInput) nameInput.focus();
      return;
    }

    if (this.addManualItem(name, sku, qty, price, notes)) {
      nameInput.value = '';
      skuInput.value = '';
      qtyInput.value = '1';
      priceInput.value = '';
      notesInput.value = '';
      if (nameInput) nameInput.focus();
    }
  },

  removeFromCart: function(id) {
    this.cart = this.cart.filter(function(item) {
      return item.id !== id;
    });
    this._saveCart();
    if (window.location.pathname.indexOf('/pages/rfq') > -1) {
      this.renderFullCart();
    }
  },

  updateItem: function(id, field, value) {
    var item = this.cart.find(function(i) { return i.id === id; });
    if (item) {
      if (field === 'quantity') {
        item[field] = Math.max(1, parseInt(value || 1));
      } else {
        item[field] = value;
      }
      localStorage.setItem('ch_rfq_cart', JSON.stringify(this.cart));
      
      // Update counts silently in other components
      var countElements = document.querySelectorAll('.rfq-cart-count');
      for (var i = 0; i < countElements.length; i++) {
        countElements[i].textContent = this.cart.length;
      }

      // Dynamic focus-safe visual save feedback
      var indicator = document.getElementById('save-indicator-' + id + '-' + field);
      if (indicator) {
        indicator.textContent = '保存済';
        indicator.style.color = '#4ccbd5';
        indicator.style.opacity = '1';
        
        // Use a stored timeout ID to prevent overlapping transitions
        if (indicator.timeoutId) {
          clearTimeout(indicator.timeoutId);
        }
        indicator.timeoutId = setTimeout(function() {
          indicator.style.opacity = '0';
        }, 1200);
      }
    }
  },

  clearCart: function() {
    if (confirm('見積カートを空にしてもよろしいですか？')) {
      this.cart = [];
      this._saveCart();
      if (window.location.pathname.indexOf('/pages/rfq') > -1) {
        this.renderFullCart();
      }
    }
  },

  openCart: function() {
    var drawer = document.getElementById('ch-rfq-drawer');
    var overlay = document.getElementById('ch-rfq-drawer-overlay');
    if (!drawer || !overlay) return;
    
    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  },

  closeCart: function() {
    var drawer = document.getElementById('ch-rfq-drawer');
    var overlay = document.getElementById('ch-rfq-drawer-overlay');
    if (!drawer || !overlay) return;

    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  },

  updateCartUI: function() {
    var countElements = document.querySelectorAll('.rfq-cart-count');
    var count = this.cart.length;
    for (var i = 0; i < countElements.length; i++) {
      countElements[i].textContent = count;
      if (count > 0) {
        countElements[i].classList.add('has-items');
      } else {
        countElements[i].classList.remove('has-items');
      }
    }

    var emptyState = document.getElementById('ch-rfq-cart-empty');
    var itemsWrap = document.getElementById('ch-rfq-cart-items-wrap');
    var itemsContainer = document.getElementById('ch-rfq-cart-items');

    if (!emptyState || !itemsWrap || !itemsContainer) return;

    if (count === 0) {
      emptyState.style.display = 'flex';
      itemsWrap.style.display = 'none';
    } else {
      emptyState.style.display = 'none';
      itemsWrap.style.display = 'flex';
      
      var html = '';
      for (var j = 0; j < this.cart.length; j++) {
        var item = this.cart[j];
        html += '<div class="ch-rfq-cart-item">';
        if (item.image) {
          if (item.url) {
            html += '<a href="' + item.url + '" onclick="window.ComponentHubRFQ.closeCart()"><img src="' + item.image + '" alt="' + item.name + '" class="ch-rfq-cart-img"></a>';
          } else {
            html += '<img src="' + item.image + '" alt="' + item.name + '" class="ch-rfq-cart-img">';
          }
        } else {
          html += '<div class="ch-rfq-cart-img-placeholder">RFQ</div>';
        }
        html += '<div class="ch-rfq-cart-item-info">';
        if (item.url) {
          html += '<p class="ch-rfq-cart-item-title"><a href="' + item.url + '" onclick="window.ComponentHubRFQ.closeCart()" style="color: var(--text); text-decoration: none; font-weight: 700; hover: underline;">' + item.name + '</a></p>';
        } else {
          html += '<p class="ch-rfq-cart-item-title">' + item.name + '</p>';
        }
        html += '<p class="ch-rfq-cart-item-sku">' + item.sku + '</p>';
        html += '<div class="ch-rfq-cart-item-meta">数量: ' + item.quantity + '</div>';
        html += '</div>';
        html += '<button type="button" class="ch-rfq-cart-remove" onclick="window.ComponentHubRFQ.removeFromCart(\'' + item.id + '\')"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>';
        html += '</div>';
      }
      itemsContainer.innerHTML = html;
    }
  },

  renderFullCart: function() {
    var container = document.getElementById('ch-full-cart-items');
    if (!container) return;

    var submitBtn = document.getElementById('ch-rfq-submit-btn');

    var html = '<div class="ch-rfq-table-responsive"><table class="ch-rfq-table">';
    html += '<thead><tr><th>製品・型番</th><th style="width: 100px;">数量</th><th style="width: 120px;">希望単価</th><th>備考 / 納期条件など</th><th style="width: 80px;"></th></tr></thead><tbody>';

    if (this.cart.length === 0) {
      html += '<tr><td colspan="5" style="text-align: center; padding: 4rem 1rem; color: var(--text-dim);">';
      html += '<div style="margin: 0 auto; max-width: 400px;">';
      html += '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="color: var(--text-dim); opacity: 0.6; margin-bottom: 1rem;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>';
      html += '<p style="margin: 0 0 0.5rem; font-weight: 600; font-size: 1rem; color: var(--text);">見積カートは現在空です</p>';
      html += '<p style="margin: 0; font-size: 0.85rem; color: var(--text-muted);">以下の入力欄から直接製品名や型番を入力してリストを作成するか、下部の一括アップロードをご利用ください。</p>';
      html += '</div>';
      html += '</td></tr>';
      if (submitBtn) submitBtn.disabled = true;
    } else {
      if (submitBtn) submitBtn.disabled = false;
      for (var i = 0; i < this.cart.length; i++) {
        var item = this.cart[i];
        var isManual = item.id.indexOf('item_manual_') === 0;
        
        html += '<tr class="' + (isManual ? 'manual-row' : 'catalog-row') + '">';
        html += '<td data-label="製品・型番">';
        html += '<div class="ch-rfq-table-product">';
        if (item.image) {
          if (item.url) {
            html += '<a href="' + item.url + '"><img src="' + item.image + '" alt=""></a>';
          } else {
            html += '<img src="' + item.image + '" alt="">';
          }
        } else {
          html += '<div class="placeholder-img" style="background: linear-gradient(135deg, var(--surface2), #ffffff); border: 1px dashed var(--border); font-size: 0.75rem; font-weight: 700; color: var(--text-muted); display:flex; align-items:center; justify-content:center; width: 48px; height: 48px; border-radius: 8px;">手動</div>';
        }
        html += '<div>';
        if (item.url) {
          html += '<strong><a href="' + item.url + '" style="color: var(--text); text-decoration: none; hover: underline;">' + item.name + '</a></strong>';
        } else {
          html += '<strong>' + item.name + '</strong>';
        }
        html += '<span style="margin-top: 0.25rem; display: inline-block;">' + item.sku + '</span></div>';
        html += '</div></td>';
        html += '<td data-label="数量"><input type="number" min="1" value="' + item.quantity + '" class="ch-input-sm" style="width: 80px;" oninput="window.ComponentHubRFQ.updateItem(\'' + item.id + '\', \'quantity\', this.value)"><div id="save-indicator-' + item.id + '-quantity" class="save-indicator-box" style="font-size:0.65rem; opacity:0; transition:opacity 0.2s; height: 12px; margin-top:2px; font-weight:600; text-align:center;"></div></td>';
        html += '<td data-label="希望単価"><input type="text" placeholder="例: ¥100" value="' + (item.targetPrice || '') + '" class="ch-input-sm" style="width: 100px;" oninput="window.ComponentHubRFQ.updateItem(\'' + item.id + '\', \'targetPrice\', this.value)"><div id="save-indicator-' + item.id + '-targetPrice" class="save-indicator-box" style="font-size:0.65rem; opacity:0; transition:opacity 0.2s; height: 12px; margin-top:2px; font-weight:600; text-align:center;"></div></td>';
        html += '<td data-label="備考 / 仕様"><input type="text" placeholder="特記事項 / 希望仕様など" value="' + (item.notes || '') + '" class="ch-input-sm ch-input-wide" oninput="window.ComponentHubRFQ.updateItem(\'' + item.id + '\', \'notes\', this.value)"><div id="save-indicator-' + item.id + '-notes" class="save-indicator-box" style="font-size:0.65rem; opacity:0; transition:opacity 0.2s; height: 12px; margin-top:2px; font-weight:600; padding-left: 5px;"></div></td>';
        html += '<td><button type="button" class="btn-ghost btn-sm" onclick="window.ComponentHubRFQ.removeFromCart(\'' + item.id + '\')" style="color: #ef4444; border: none; background: transparent; cursor: pointer;">削除</button></td>';
        html += '</tr>';
      }
    }

    // Always append the Manual Entry Form row at the bottom
    html += '<tr class="ch-rfq-manual-row-form" style="background-color: var(--surface);">';
    html += '<td data-label="新規製品追加">';
    html += '<div style="display: flex; gap: 0.5rem; flex-direction: column; padding: 0.5rem 0;">';
    html += '<input type="text" id="manual-name" placeholder="製品名・部品名 (必須)" class="ch-input-sm" style="width: 100%; min-width: 150px; background: #fff;">';
    html += '<input type="text" id="manual-sku" placeholder="型番/SKU (必須)" class="ch-input-sm" style="width: 100%; min-width: 150px; background: #fff;">';
    html += '</div>';
    html += '</td>';
    html += '<td data-label="数量"><input type="number" id="manual-qty" min="1" value="1" class="ch-input-sm" style="width: 80px; height: 38px; background: #fff; margin: 0.5rem 0;"></td>';
    html += '<td data-label="希望単価"><input type="text" id="manual-price" placeholder="例: ¥100" class="ch-input-sm" style="width: 100px; height: 38px; background: #fff; margin: 0.5rem 0;"></td>';
    html += '<td data-label="備考 / 仕様"><input type="text" id="manual-notes" placeholder="仕様・代替品可否・希望納期など" class="ch-input-sm ch-input-wide" style="width: 100%; height: 38px; background: #fff; margin: 0.5rem 0;"></td>';
    html += '<td><button type="button" class="btn-primary btn-sm" onclick="window.ComponentHubRFQ.submitManualItemForm(event)" style="white-space: nowrap; height: 38px; width: 100%; margin: 0.5rem 0; font-weight: 600;">追加</button></td>';
    html += '</tr>';

    html += '</tbody></table></div>';
    container.innerHTML = html;
  },

  submitFullQuote: function(e) {
    if (e) e.preventDefault();

    // Auto-add pending manual row item if either name or sku has been filled in
    var nameInput = document.getElementById('manual-name');
    var skuInput = document.getElementById('manual-sku');
    if (nameInput && skuInput) {
      var mName = nameInput.value.trim();
      var mSku = skuInput.value.trim();
      if (mName || mSku) {
        var mQty = document.getElementById('manual-qty').value;
        var mPrice = document.getElementById('manual-price').value;
        var mNotes = document.getElementById('manual-notes').value;
        
        var pName = mName || mSku;
        var pSku = mSku || mName;
        
        this.cart.push({
          id: 'item_manual_' + Date.now(),
          name: pName,
          sku: pSku,
          image: '',
          quantity: Math.max(1, parseInt(mQty || 1)),
          targetPrice: mPrice,
          notes: mNotes,
          url: ''
        });
        this._saveCart();
      }
    }

    if (this.cart.length === 0) {
      alert('見積カートが空です。製品を追加してください。');
      return;
    }

    var requiredFields = document.querySelectorAll('#rfq-customer-info [required]');
    for (var i = 0; i < requiredFields.length; i++) {
      var field = requiredFields[i];
      if (!field.value.trim()) {
        alert('必須項目を入力してください。');
        field.focus();
        return;
      }
    }

    var rfqId = 'RFQ-' + Date.now().toString(36).toUpperCase();
    var submittedAt = new Date().toLocaleString('ja-JP');

    var companyVal = document.getElementById('rfq-company').value.trim();
    var deptVal = document.getElementById('rfq-dept') ? document.getElementById('rfq-dept').value.trim() : '-';
    var nameVal = document.getElementById('rfq-name').value.trim();
    var emailVal = document.getElementById('rfq-email').value.trim();
    var phoneVal = document.getElementById('rfq-phone') ? document.getElementById('rfq-phone').value.trim() : '-';
    var addressVal = document.getElementById('rfq-address') ? document.getElementById('rfq-address').value.trim() : '-';
    var generalNotesVal = document.getElementById('rfq-general-notes') ? document.getElementById('rfq-general-notes').value.trim() : '-';

    var body = [
      'B2B バルク見積依頼 / RFQ',
      'RFQ ID: ' + rfqId,
      '受付日時: ' + submittedAt,
      '',
      '[ お客様情報 ]',
      '会社名: ' + companyVal,
      '部署名: ' + deptVal,
      'ご担当者名: ' + nameVal,
      'メールアドレス: ' + emailVal,
      '電話番号: ' + phoneVal,
      'お届け先住所: ' + addressVal,
      '',
      '[ 見積依頼製品一覧 (' + this.cart.length + '件) ]'
    ];

    for (var j = 0; j < this.cart.length; j++) {
      var item = this.cart[j];
      body.push(
        (j + 1) + '. 型番: ' + item.sku + ' | 製品名: ' + item.name,
        '   数量: ' + item.quantity + ' | 希望単価: ' + (item.targetPrice || '指定なし'),
        '   備考: ' + (item.notes || 'なし')
      );
    }

    body.push(
      '',
      '[ 全体備考 ]',
      generalNotesVal
    );

    var form = document.getElementById('ch-rfq-full-form');
    var bodyInput = document.getElementById('ch-rfq-body-input');
    if (bodyInput) {
      bodyInput.value = body.join('\n');
    }

    var submitBtn = document.getElementById('ch-rfq-submit-btn');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = '送信中...';
    }

    var cartItemsCopy = this.cart.map(function(item) {
      return {
        name: item.name,
        sku: item.sku,
        quantity: item.quantity,
        targetPrice: item.targetPrice || '指定なし',
        notes: item.notes || 'なし',
        url: item.url || ''
      };
    });

    var self = this;
    
    // 1. Persist to customer local history
    this._persistHistory({
      id: rfqId,
      date: submittedAt,
      company: companyVal,
      itemCount: cartItemsCopy.length,
      status: '送信済み',
      items: cartItemsCopy
    });

    // 2. Persist to global admin registry
    this._persistGlobalAdmin({
      id: rfqId,
      date: submittedAt,
      company: companyVal,
      name: nameVal,
      email: emailVal,
      phone: phoneVal,
      address: addressVal,
      generalNotes: generalNotesVal,
      itemCount: cartItemsCopy.length,
      status: '未対応', // Default status: Pending
      items: cartItemsCopy
    });

    // 3. Set temporary submission flag in localStorage so the success page knows to clear the cart
    localStorage.setItem('ch_rfq_just_submitted', 'true');

    // 4. Submit to Google Sheets if database webhook URL is configured
    if (window.CH_DATABASE_WEBHOOK_URL) {
      var payload = {
        action: "create",
        id: rfqId,
        date: submittedAt,
        company: companyVal,
        name: nameVal,
        email: emailVal,
        phone: phoneVal,
        address: addressVal,
        generalNotes: generalNotesVal,
        itemCount: cartItemsCopy.length,
        status: '未対応',
        items: cartItemsCopy
      };
      
      fetch(window.CH_DATABASE_WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain;charset=utf-8'
        },
        body: JSON.stringify(payload),
        redirect: 'follow'
      }).then(function() {
        form.submit();
      }).catch(function() {
        form.submit();
      });
    } else {
      // Submit natively immediately
      form.submit();
    }
  },

  _persistHistory: function(entry) {
    try {
      var history = JSON.parse(localStorage.getItem('ch_rfq_history') || '[]');
      history.unshift(entry);
      if (history.length > 50) history = history.slice(0, 50);
      localStorage.setItem('ch_rfq_history', JSON.stringify(history));
    } catch (error) {}
  },

  _persistGlobalAdmin: function(entry) {
    try {
      var globalRfqs = JSON.parse(localStorage.getItem('ch_global_admin_rfqs') || '[]');
      globalRfqs.unshift(entry);
      if (globalRfqs.length > 500) globalRfqs = globalRfqs.slice(0, 500);
      localStorage.setItem('ch_global_admin_rfqs', JSON.stringify(globalRfqs));
    } catch (error) {}
  },

  _bindEvents: function() {
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') window.ComponentHubRFQ.closeCart();
    });
  }
};

document.addEventListener('DOMContentLoaded', function() {
  window.ComponentHubRFQ.init();
});
